import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import '../../styles/carrosselConvenios.css';

import convenioCanoasPrev from '../../img/conveniosimg/canoasprev.jpg';

const CarrosselConvenios: React.FC = () => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <>
      <div className="white_background">
        <div ref={ref} className="carousel_container_convenios_canoas">
          {inView && (
            <div className="convenio_bloco_wrapper">
              <div className="convenio_linha">
                <motion.div
                  initial={{ x: 150, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 1 }}
                  className="convenio_bloco_canoas"
                >
                  <a href="http://www.canoasprev.rs.gov.br/" target="_blank" rel="noopener noreferrer">
                  <img src={convenioCanoasPrev} alt="CanoasPrev" className="convenio_imagem" /></a>
                  <div className="convenio_texto">
                    <h3><b>CanoasPrev</b></h3>
                    <p className="text_convenio_canoas">
                      O CanoasPrev é o instituto de previdência dos servidores de Canoas, oferecendo benefícios e cobertura médica aos seus segurados.
                    </p>
                  </div>
                </motion.div>
              </div>
            </div>
          )}
        </div>
      </div>
      <hr></hr>
    </>
  );
};

export default CarrosselConvenios;
